
import { Component, Vue, Prop } from "nuxt-property-decorator";
import { BIconImages } from "bootstrap-vue";

@Component({
  components: {
    BIconImages,
  },
})
export default class TheMedia extends Vue {
  @Prop() item!: any;

  get presetStyle(): string {
    return this.$store.getters["preset/style"];
  }

  get hasBothMediaTypes(): boolean {
    return !!(this.item?.tabs?.media_gallery?.videoGallery?.length && this.item?.tabs?.media_gallery?.new_tour?.length);
  }

  get tourVariant(): string {
    return this.hasBothMediaTypes ? `outline-${this.presetStyle}` : this.presetStyle;
  }
}
